import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";

import messages from "../../../assets/locale/messages";
import { UIModal } from "../../ui";
import RequestSummary from "../RequestSummary";

/** Confirms accepting a publishing or crew size change request. */
const AcceptRequestModal = ({ request, submitting, onClose, onConfirm }) => {
  const lang = useSelector((state) => state.locale.lang);
  const { publishingRequests: t, shared } = messages[lang];
  const copy = request ? t[request.type] : null;
  const close = () => !submitting && onClose();

  return (
    <UIModal
      open={Boolean(request)}
      type="success"
      title={copy?.acceptTitle}
      description={copy?.acceptDescription}
      cancelLabel={shared.cancel}
      confirmLabel={t.accept}
      onClose={close}
      onCancel={close}
      onConfirm={() => !submitting && onConfirm(request)}
      cancelButtonProps={{ disabled: submitting }}
      confirmButtonProps={{ disabled: submitting }}
      PaperProps={{ className: "publishing-request-modal" }}
    >
      {request && (
        <RequestSummary
          request={request}
          amountLabel={t.summary.crewFee}
        />
      )}
    </UIModal>
  );
};

AcceptRequestModal.propTypes = {
  /** The request to accept; null keeps the popup closed. */
  request: PropTypes.object,
  /** The accept is being sent: the buttons wait. */
  submitting: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

AcceptRequestModal.defaultProps = {
  request: null,
  submitting: false,
};

export default AcceptRequestModal;
